module.exports = __webpack_public_path__ + "static/media/habbit-tracker2.181af2b4.jpg";